export var toPennySortingState = sorting => {
  var singleColumnSorting = sorting && sorting.length > 0 ? sorting[0] : undefined;

  if (!singleColumnSorting) {
    return undefined;
  }

  return {
    id: singleColumnSorting.id,
    sortDirection: singleColumnSorting.desc ? 'desc' : 'asc'
  };
};
export var toReactTableSortingState = sorting => {
  if (!sorting) {
    return [];
  }

  return [{
    id: sorting.id,
    desc: sorting.sortDirection === 'desc'
  }];
};
export var toReactTableOnSortingChange = onSortingChange => nextSortingState => {
  if (!onSortingChange) {
    return;
  }

  if (typeof nextSortingState === 'function') {
    onSortingChange(prevState => {
      var reactTablePrevState = toReactTableSortingState(prevState);
      var reactTableNextState = nextSortingState(reactTablePrevState);
      return toPennySortingState(reactTableNextState);
    });
    return;
  }

  onSortingChange(toPennySortingState(nextSortingState));
};
//# sourceMappingURL=tableSorting.utils.js.map